(function () {
  angular.module("akitabox.ui.components.roomStats", [
    "akitabox.core.constants",
    "akitabox.core.services.floor",
    "akitabox.core.services.room",
    "akitabox.core.toast",
    "akitabox.ui.directives.donutChart",
  ]);
})();
